<template>
  <div
    class="tw-m-4 tw-bg-white tw-shadow-lg tw-rounded tw-px-8 tw-pt-2 tw-pb-8 tw-mb-4"
  >
    <div class="tw-flex tw-flex-start tw-justify-between">
      <p
        class="tw-mx-4 tw-block tw-mt-8 tw-text-eko-orange tw-font-bold tw-text-2xl"
      >
        Carbon Emmission Calculator
      </p>
    </div>
    <div class="tw-w-full tw-flex tw-items-center tw-justify-center">
      <div class="tw-block tw-w-full tw-mx-auto">
        <div class="tw-mx-4 tw-bg-white tw-px-8 tw-pb-8 tw-mb-4">
          <div class="text-center">
            <div width="500">
              <div>
                <div class="tw-flex tw-flex-wrap">
                  <div class="tw-my-2 tw-w-full md:tw-w-1/2">
                    <div class="tw-mx-2">
                      <label
                        class="tw-block tw-uppercase tw-text-gray-700 tw-text-left tw-text-sm tw-font-bold tw-mb-2"
                        for="Start Location"
                        >Start Location</label
                      >
                      <gmap-autocomplete
                        placeholder="Trip start location"
                        class="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline input-address"
                        @place_changed="setStartPlace"
                      ></gmap-autocomplete>
                      <p
                        v-if="errors.start"
                        class="tw-text-xs tw-text-left tw-text-red-500"
                      >
                        Please enter start location
                      </p>
                    </div>
                  </div>
                  <div class="tw-my-2 tw-w-full md:tw-w-1/2">
                    <div class="tw-mx-2">
                      <label
                        class="tw-block tw-uppercase tw-text-gray-700 tw-text-left tw-text-sm tw-font-bold tw-mb-2"
                        for="Start Location"
                        >End Location</label
                      >
                      <gmap-autocomplete
                        placeholder="Trip end location"
                        class="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline input-address"
                        @place_changed="setEndPlace"
                      ></gmap-autocomplete>
                      <p
                        v-if="errors.end"
                        class="tw-text-xs tw-text-left tw-text-red-500"
                      >
                        Please enter end location
                      </p>
                    </div>
                  </div>
                </div>

                <div class="tw-flex tw-flex-wrap">
                  <div class="tw-my-2 tw-w-full md:tw-w-1/2">
                    <div class="tw-mx-2">
                      <label
                        class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-sm tw-text-left tw-font-bold tw-mb-2"
                        for="grid-state"
                      >
                        Select mode of transport
                      </label>
                      <div class="tw-relative">
                        <select
                          class="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline input-address"
                          id="grid-state"
                          v-model="data.trip"
                        >
                          <option disabled value="undefined">
                            Select an option
                          </option>
                          <option value="air">Air Travel</option>
                          <option value="road">Road Travel</option>
                        </select>
                        <div
                          class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-text-gray-700"
                        >
                          <svg
                            class="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path
                              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                            />
                          </svg>
                        </div>
                      </div>
                      <p
                        v-if="errors.trip"
                        class="tw-text-xs tw-text-left tw-text-red-500"
                      >
                        Please select trip type
                      </p>
                    </div>
                  </div>

                  <div class="tw-my-2 tw-w-full md:tw-w-1/2">
                    <div class="tw-mx-2">
                      <label
                        class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-sm tw-text-left tw-font-bold tw-mb-2"
                        for="grid-state"
                      >
                        Select trip type
                      </label>
                      <div class="tw-relative">
                        <select
                          class="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline input-address"
                          id="grid-state"
                          v-model="data.type"
                        >
                          <option disabled value="undefined">
                            Select an option
                          </option>
                          <option value="1">One Way</option>
                          <option value="2">Two Way</option>
                        </select>
                        <div
                          class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-text-gray-700"
                        >
                          <svg
                            class="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path
                              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                            />
                          </svg>
                        </div>
                      </div>
                      <p
                        v-if="errors.type"
                        class="tw-text-xs tw-text-left tw-text-red-500"
                      >
                        Please select trip type
                      </p>
                    </div>
                  </div>
                </div>

                <div v-if="data.trip == 'road'" class="tw-flex tw-flex-wrap">
                  <div class="tw-my-2 tw-w-full md:tw-w-1/2">
                    <div class="tw-mx-2">
                      <label
                        class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-sm tw-text-left tw-font-bold tw-mb-2"
                        for="grid-state"
                      >
                        Select vehicle type
                      </label>
                      <div class="tw-relative">
                        <select
                          class="tw-shadow tw-appearance-none tw-border tw-rounded tw-w-full tw-py-2 tw-px-3 tw-text-gray-700 tw-leading-tight focus:tw-outline-none focus:tw-shadow-outline input-address"
                          id="grid-state"
                          v-model="data.vehicle"
                        >
                          <option disabled value="undefined">
                            Select an option
                          </option>
                          <option value="0.00016">
                            Car with petrol 1.4 Litre of engine
                          </option>
                          <option value="0.0002">
                            Medium- petrol 1.4 - 2.1 Litres
                          </option>
                          <option value="0.00022">
                            Large - 2.1 Litres and Above
                          </option>
                          <option value="0.0016">
                            Small Diesel - 2.0 Litres Below
                          </option>
                          <option value="0.002">
                            Large Diesel - 2.0 Litres Abovr
                          </option>
                        </select>
                        <div
                          class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-text-gray-700"
                        >
                          <svg
                            class="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path
                              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                            />
                          </svg>
                        </div>
                      </div>
                      <p
                        v-if="errors.vehicle"
                        class="tw-text-xs tw-text-left tw-text-red-500"
                      >
                        Please select vehicle type
                      </p>
                    </div>
                  </div>
                </div>

                <v-divider class="tw-my-6"></v-divider>
                <br />
                <!-- <p v-if="difference" class="tw-text-left">
                  Trip Distance: <strong>{{ difference }} (KM)</strong>
                </p> -->
                <p v-if="carbon" class="tw-text-left">
                  Emmission Value: <strong>{{ carbon }} tCO2e </strong>
                </p>
              </div>
            </div>
          </div>

          <vue-element-loading
            v-if="loading"
            :active="loading"
            :is-full-screen="true"
          />
          <div class="tw-flex tw-items-center tw-justify-between">
            <button
              @click.prevent="submit"
              class="tw-bg-eko-orange hover:tw-bg-eko-dark tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded focus:tw-outline-none focus:tw-shadow-outline"
              type="button"
            >
              Calculate
            </button>

            <button
              v-if="carbon && difference"
              @click.prevent="save"
              class="tw-bg-eko-dark hover:tw-bg-eko-orange tw-text-white tw-font-bold tw-py-2 tw-px-4 tw-rounded focus:tw-outline-none focus:tw-shadow-outline"
              type="button"
            >
              Save Result
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as geolib from "geolib";
export default {
  data() {
    return {
      data: {},
      loading: false,
      error: false,
      errors: {},
      user: {},
      token: "",
      admin: null,
      carbon: "",
      price: 0,
      difference: "",
      start: {},
      end: {},
      trip: "",
    };
  },
  components: {},
  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
  },
  methods: {
    setStartPlace(place) {
      this.start.address = place.formatted_address;
      this.start.lat = place.geometry.location.lat();
      this.start.lng = place.geometry.location.lng();
    },
    setEndPlace(place) {
      this.end.address = place.formatted_address;
      this.end.lat = place.geometry.location.lat();
      this.end.lng = place.geometry.location.lng();
    },
    save() {
      const self = this;
      this.loading = true;
      let dt = {};
      dt.owner_id = this.user._id;
      dt.totalCarbonEmmision = this.carbon;
      console.log(dt);
      axios
        .post(`${this.$baseUrl}/carbon/create`, dt, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          self.$swal("Success!", "Saved Successfully.", "success");
          this.$router.push("/offsetter/projects/offset");
          self.loading = false;
          self.success = true;
          self.dialog = false;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          let err_msg = error.response.data
            ? error.response.data.message
            : "An error occured";
          self.$swal("Error!", err_msg, "error");
        });
    },
    submit() {
      let deny = false;
      this.errors = {};
      this.loading = true;
      if (!this.start.lng) {
        this.errors.start = true;
        deny = true;
      }
      if (!this.end.lng) {
        this.errors.end = true;
        deny = true;
      }
      if (!this.data.trip) {
        this.errors.trip = true;
        deny = true;
      }

      if (!this.data.type) {
        this.errors.type = true;
        deny = true;
      }

      if (this.data.trip == "road" && !this.data.vehicle) {
        this.errors.vehicle = true;
        deny = true;
      }

      if (deny) {
        this.loading = false;
        return;
      }

      this.difference = geolib.getDistance(
        { latitude: this.start.lat, longitude: this.start.lng },
        { latitude: this.end.lat, longitude: this.end.lng }
      );

      this.difference = this.difference / 1000;
      console.log(this.difference);
      switch (this.data.trip) {
        case "road":
          this.carbon =
            this.difference *
            parseInt(this.data.type) *
            parseFloat(this.data.vehicle);
          // this.carbon = Math.round((this.carbon + Number.EPSILON) * 100) / 100;
          this.carbon = parseFloat(this.carbon.toFixed(2));
          break;
        case "air":
          this.carbon = this.difference * 0.00011 * parseInt(this.data.type);
          // this.carbon = Math.round((this.carbon + Number.EPSILON) * 100) / 100;
          this.carbon = parseFloat(this.carbon.toFixed(2));
          break;
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.log {
  height: 100vh;
  overflow: auto;
}
.my-img,
.logo {
  width: 60%;
  height: 60%;
  margin: auto;
}
</style>
